import React, { useState } from "react";
import localization from "assets/localization/localization";
import ConstantInput from "components/sales/Input/constantInput/constantInput";

const BusinessItemFilter = ({
  showFilter,
  applyFilter,
  setSelectedName,
  setSelectedCode,
  type,
}) => {

  const storageKey = type === "M" ? "material_filter" : "service_filter";

  const savedFilter = JSON.parse(window.localStorage.getItem(storageKey) || "{}");

  const [filterFieldsData, setFilterFieldsData] = useState({
    name: savedFilter?.name || "",
    code: savedFilter?.code || "",
  });

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        window.localStorage.setItem(storageKey, JSON.stringify(filterFieldsData));
        applyFilter(filterFieldsData);
      }}
    >
      <ConstantInput
        label="Item Name"
        type="text"
        isStarRequired={false}
        value={filterFieldsData.name}
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            name: val,
          });
          setSelectedName(val);
        }}
      />

      <ConstantInput
        label="Item Code"
        type="text"
        isStarRequired={false}
        value={filterFieldsData.code}
        handleChange={(val) => {
          setFilterFieldsData({
            ...filterFieldsData,
            code: val,
          });
          setSelectedCode(val);
        }}
      />

      <div className="btn-wrapper">
        <button disabled={false} type="submit" className="btn btn-primary">
          {localization.applyFilter}
          <img src="../images/arrow-right.png" alt="" />
        </button>

        <br />
        <br />

        <button
          onClick={() => {
            setSelectedName("");
            setSelectedCode("");
            window.localStorage.removeItem(storageKey);
            window.location.reload();
          }}
          type="button"
          className="btn btn-primary"
        >
          {localization.removeFilter}
        </button>
      </div>
    </form>
  );
};

export default BusinessItemFilter;
